import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';
import { 
  FaQuestion,
  FaClock
} from 'react-icons/fa';
import './qa.css';
import { auth, db } from '../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../auth/cache_manager';

function QA() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define Q&A sections with icons and descriptions
  const qaSections = [
    {
      title: 'Ask a Question?',
      icon: <FaQuestion className="blg_qa_section-icon" />,
      description: 'Post your USMLE-related questions and get expert answers'
    },
    {
      title: 'Q&A Timeline',
      icon: <FaClock className="blg_qa_section-icon" />,
      description: 'Browse through previously asked questions and answers'
    }
  ];

  return (
    <div className={`blg_qa-container ${isDarkMode ? 'blg_qa_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="blg_qa-content">
        <div className="blg_qa-header">
          <h1>Questions & Answers</h1>
          <p>Get answers to your USMLE preparation questions from experts and peers</p>
        </div>

        <div className="blg_qa-sections-grid">
          {qaSections.map((section, index) => (
            <div 
              key={index}
              className="blg_qa-section-card"
            >
              <div className="blg_qa-icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="blg_qa-coming-soon">Coming Soon</div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default QA; 